import Ls from '@/services/ls'
import * as types from './mutation-types'
import { UPDATE_APP_LOADING_STATUS } from "@/store/mutation-types";
import router from '@/router/index'

export const login = ({ commit, dispatch, state }, data) => {
    const loginData = {
        phone: data.phone,
        password: data.password
    }
    return new Promise((resolve, reject) => {
        window.axios.post('login', loginData).then((response) => {
            const token = response.data.token
            Ls.set('auth.token', token)
            commit(types.AUTH_SUCCESS, token)
            resolve(response)
        }).catch(err => {
            Ls.remove('auth.token')
            reject(err)
        })
    })
}


export const logout = ({ commit }, noRequest = false) => {
    if (noRequest) {
        commit(types.AUTH_LOGOUT)
        Ls.remove('auth.token')
        router.push({name: 'login-index'})
        return true
    }

    return new Promise((reject) => {
        window.axios.post('/logout').then((response) => {
            commit(types.AUTH_LOGOUT)
            commit(UPDATE_APP_LOADING_STATUS, false, {root: true})
            Ls.remove('auth.token')
            router.push({name: 'login-index'})
            window.toastr['success'](response.data.message)
        }).catch(err => {
            reject(err)
            commit(types.AUTH_LOGOUT)
            Ls.remove('auth.token')
            router.push({name: 'login-index'})
        })
    })
}